module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTDNv/zNv/zJv/zNv/zBw/zJv/zJu/zBw/zJv/zNv/+9MqvYAAAAKdFJOUwC9luPPIEBgEHWJPbnEAAAAlUlEQVQoz2NgoAZgU14FB4udEiCCHFqrkMHCALBoyypUYAoW1UITXQwSZF2FDgqAokwYogJAURYMUQOgKBeG6IJRUQKizBiiDlhDXQEU7xiiAdhicxHWmHdgwBL1ixogoqwqSInBKAEltQVDEw0qYF81AatoAdGijOCUhJysBYHAa9ViEIVwAgtaIoMATiTRCVTJVAwAa4VSrdo+jkIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/webht-1.png
// module id = rrqB
// module chunks = 0